import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "wrapper" ]

  activate(event) {
    event.preventDefault();
    var current = this.wrapperTarget.getElementsByClassName("active");
    if (current.length > 0) {
      current[0].className = current[0].className.replace(" active", "");
    }
    
    event.currentTarget.className += " active";
  }
}
